"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushEvent = void 0;
const utils_1 = require("./utils");
function pushEvent(eventPayload) {
    if ((0, utils_1.hasAnalyticsUserConsent)()) {
        gtag(eventPayload.event, (0, utils_1.removeAllEmptiesFrom)(eventPayload));
    }
}
exports.pushEvent = pushEvent;
const gtag = (eventName, eventPayload) => {
    if (window.gtag) {
        window.gtag("event", eventName, eventPayload);
    }
};
//# sourceMappingURL=googleAnalytics4.js.map